import axios from 'axios';
const baseURL = "https://api.jesse.photo/api/";

const getNonce = () =>{
    const request = axios.get(`${baseURL}nonce/`);
    return request.then(response => response.data);
}

export default { getNonce }